module.exports = "/assets/data/d0b532eaaa0cb3f318489b3e6798adbf-EC3N.data.json";